/**
 * Ferry-specific general validations for passenger selection
 * İmza: (values, incrementValues, settings) => { errors }
 */
export const ferryPassengerGeneralValidations = (
  values,
  incrementValues,
  settings,
) => {
  const errors = {};
  const warnings = {};
  const total = Object.values(incrementValues).reduce(
    (sum, val) => sum + (typeof val === "number" ? val : 0),
    0,
  );

  // Total max
  if (
    settings?.totalSelections !== undefined &&
    total > settings.totalSelections
  ) {
    errors.general = {
      titleKey: "ferry.passengerMaxTitle",
      descriptionKey: "ferry.passengerMaxDescription",
    };
  }

  // Total tam eşit olduğunda uyarı göster (daha fazla seçemezsin)
  if (
    settings?.totalSelections !== undefined &&
    total >= settings.totalSelections
  ) {
    warnings.general = {
      titleKey: "ferry.passengerMaxTitle",
      descriptionKey: "ferry.passengerMaxDescription",
    };
  }

  // Total min
  if (
    settings?.minTotalSelections !== undefined &&
    total < settings.minTotalSelections
  ) {
    errors.general = {
      titleKey: "ferry.passengerMinTitle",
      descriptionKey: "ferry.passengerMinDescription",
    };
  }

  // Bebek > Yetişkin değil - (otobüste infant türü olmayabilir, örnek kural)
  if (
    incrementValues?.infant !== undefined &&
    incrementValues?.adult !== undefined &&
    incrementValues.infant > incrementValues.adult
  ) {
    errors.general = {
      titleKey: "ferry.passengerInfantAdultTitle",
      descriptionKey: "ferry.passengerInfantAdultDescription",
    };
  }

  // child > childAges.length
  // if (values.child > values.childAges.filter((age) => age !== "").length) {
  //   errors.general = {
  //     titleKey: "ferry.passengerChildAgesTitle",
  //     descriptionKey: "ferry.passengerChildAgesDescription",
  //   };
  // }

  return { errors, warnings };
};
